import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="image-preview"
export default class extends Controller {
  static targets = ["input", "preview", "placeholder"]

  connect() {
    // Preview existing image on page load if present
    if (this.hasPreviewTarget) {
      this.updatePreviewVisibility()
    }
  }

  preview(event) {
    const file = event.target.files[0]

    if (file && file.type.startsWith("image/")) {
      const reader = new FileReader()

      reader.onload = (e) => {
        // Update the preview image source
        if (this.hasPreviewTarget) {
          this.previewTarget.src = e.target.result
          this.previewTarget.classList.remove("hidden")
        }

        // Hide the placeholder if it exists
        if (this.hasPlaceholderTarget) {
          this.placeholderTarget.classList.add("hidden")
        }
      }

      reader.readAsDataURL(file)
    }
  }

  clear() {
    // Reset the file input
    if (this.hasInputTarget) {
      this.inputTarget.value = ""
    }

    // Hide the preview
    if (this.hasPreviewTarget) {
      this.previewTarget.src = ""
      this.previewTarget.classList.add("hidden")
    }

    // Show the placeholder again
    if (this.hasPlaceholderTarget) {
      this.placeholderTarget.classList.remove("hidden")
    }
  }

  updatePreviewVisibility() {
    // Show preview if it has a src attribute (existing image)
    if (this.previewTarget.src && this.previewTarget.src !== window.location.href) {
      this.previewTarget.classList.remove("hidden")
      if (this.hasPlaceholderTarget) {
        this.placeholderTarget.classList.add("hidden")
      }
    }
  }
}
